import { Toggle } from "shared/components/Toggle";
import styles from "../../../styles/integrations.module.scss";
import { Button } from "../../components/Button";
import { Hairline } from "../../components/Hairline";
import { Input } from "../../components/Input";
import { If } from "../../components/control-statements/If";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import { PickupAddressStep } from "./PickupAddressStep";
import { RequestPermissionStep } from "./RequestPermissionStep";

function CompleteStep({
  loading,
  account,
  brandAccount,
  onChangeStatus,
  onEditPickup,
  onEditCredentials,
}) {
  const environmentConfigurations = EnvironmentStorage.getConfigurations();

  return (
    <>
      <div className={styles.toggle}>
        <div className="d-flex justify-end w-100">
          <Toggle
            active={account?.active}
            onChange={() => onChangeStatus()}
          />
        </div>
      </div>

      <If cond={environmentConfigurations.type === "UNIT"}>
        <div className={styles.details}>
          <div className={styles.about}>
            <div className={styles.description}>
              <p className={styles.slim}>
                É necessário informar a{" "}
                <strong className={styles.highlight}>URL do webhook </strong>
                para o suporte da Mottu. É nessa URL que as alterações dos
                pedidos feitas pela plataforma da Mottu são enviadas, para que
                sejam processados pelo gestor de pedidos.
              </p>
            </div>
          </div>
        </div>

        <Input
          design="two"
          className="mb-15 mt-15"
          floatLabel="URL do webhook"
          value={account?.webhookUrl || ""}
          readOnly={true}
        />

        <Hairline className="mb-30" />
      </If>

      {brandAccount?.active && (
        <>
          <PickupAddressStep account={account} readOnly={true} />
          <div className={styles.footer}>
            <Button design="primary" onClick={onEditPickup} className="w-100 mt-15">
              Editar
            </Button>
          </div>
        </>
      )}

      {!brandAccount?.active && (
        <>
          <RequestPermissionStep account={account} readOnly={true} />
          <div className={styles.footer}>
            <Button
              design="primary"
              onClick={onEditCredentials}
              className="w-100 mt-15"
            >
              Editar
            </Button>
          </div>
        </>
      )}
    </>
  );
}

export { CompleteStep };
